import { __decorate, __metadata } from "tslib";
import { Serialize } from '@ftr/serialization';
import { LocalDateTime } from '@js-joda/core';
/**
 * Time information on an audio segment
 */
export class Timecode {
    /**
     * @param start The start date and time of the segment
     * @param duration The duration of the segment, in milliseconds
     */
    constructor(start, duration) {
        this.start = start;
        this.duration = duration;
    }
    get end() {
        // plus(this.duration, ChronoUnit.MILLIS) introduces small inaccuracies which can accumulate
        return this.start.plusNanos(this.duration * 1e6);
    }
}
__decorate([
    Serialize(() => LocalDateTime),
    __metadata("design:type", LocalDateTime)
], Timecode.prototype, "start", void 0);
